import React, { useEffect } from 'react';
import cn from 'classnames';

import style from './RoundButtonArrowMain.module.css';

type Props = {
  variant?: 'filled' | 'plain';
  pos?: 'right' | 'left' | 'bottom' | 'up';
  width?: number;
  height?: number;
  color?: string;
  className?: string;
  onClick?: React.MouseEventHandler<SVGSVGElement>;
};

function RoundButtonArrowMain({
  onClick,
  className,
  color = 'white',
  variant = 'plain',
  height = 76,
  width = 76,
}: Props): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 76 76"
      fill="none"
      onClick={onClick && onClick}
      className={cn(className, style.RoundButtonArrowMain, {
        [style.filled]: variant === 'filled',
        [style.plain]: variant === 'plain',
        [style.main]: color === 'main',
      })}
    >
      <circle
        xmlns="http://www.w3.org/2000/svg"
        cx="38"
        cy="38"
        r="37.4154"
        transform="matrix(-1 0 0 1 76 0)"
        stroke={color}
        strokeWidth="1.16923"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M37.105 29.2778L46.9963 39.1691M46.9963 39.1691L37.105 49.0604M46.9963 39.1691L29.0234 39.1691"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default RoundButtonArrowMain;
